import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'fineNumber',
})
export class FineNumberPipe implements PipeTransform {
  constructor() {

  }

  transform(value: any, args?: any): any {
    if (value === 0) {
      return 0;
    }
    if (!value) {
      return '';
    }

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

}
